import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import styles from './AssignOutletModal.css';

class AssignOutletModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assignedOutletIds: {},
      searchedOutletIds: {},
      search: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show && nextProps.show) {
      const assignedOutletIds = {};
      this.props.assignedOutletIds.forEach(oid => {
        assignedOutletIds[oid] = true;
      });
      const searchedOutletIds = {};
      this.props.outlets.forEach(o => {
        searchedOutletIds[o.id] = true;
      });
      this.setState({
        assignedOutletIds,
        search: '',
        searchedOutletIds,
      });
    }
  }

  render() {
    const { show, outlets } = this.props;
    const countShownOutlets = this._countShownOutlets();
    const countAssignedAndShown = this._countAssignedAndShown();
    const countAssignedOutlets = this._countAssignedOutlets();
    return (
      <Modal
        show={show}
        dialogClassName={styles['modal-dialog']}
        onHide={() => {
          return false;
        }}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          Assign Outlet
        </Modal.Header>
        <Modal.Body bsClass={`modal-body ${styles['modal-body']}`}>
          <div className={`${styles['search-wrapper']} right-inner-addon`}>
            <i className="fa fa-search" />
            <input
              className="form-control"
              placeholder="Search"
              onChange={this._onChangeSearch}
            />
          </div>
          <div className="row">
            {countAssignedOutlets === 0 && (
              <div className={`col-xs-12 mt-10px ${styles['one-outlet-info']}`}>
                <div className="col-xs-12">
                  You must select at least 1 outlet
                </div>
              </div>
            )}
            <div className={`col-xs-12 ${styles.row} mt-10px`}>
              <div className="col-xs-9">Select outlet</div>
              <div className="col-xs-3">
                <span className="pull-right">
                  {countShownOutlets > 0 && countAssignedAndShown === 0 && (
                    <a
                      onClick={this._onClickCheckAll}
                      href="javascript:void(0)"
                    >
                      Select All
                    </a>
                  )}
                  {countShownOutlets > 0 && countAssignedAndShown > 0 && (
                    <a
                      onClick={this._onClickUncheckAll}
                      href="javascript:void(0)"
                    >
                      Deselect All
                    </a>
                  )}
                </span>
              </div>
            </div>
            {outlets.map(o => {
              if (this._shown(o.id)) {
                return (
                  <div key={o.id} className={`col-xs-12 ${styles.row}`}>
                    <div className="col-xs-11">
                      {useMokaOutletPropsFirst(o, outlet => outlet.name)}
                    </div>
                    <div className="col-xs-1">
                      <span className="pull-right">
                        <input
                          type="checkbox"
                          checked={this._assigned(o.id)}
                          onClick={() => {
                            this._onClickCheckbox({ id: o.id });
                          }}
                        />
                      </span>
                    </div>
                  </div>
                );
              }
              return <div key={o.id} />;
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-left">
            <span className={styles['selected-outlet']}>
              Selected Outlet : {countAssignedOutlets}
            </span>
          </span>
          <span className="pull-right">
            <button onClick={this._onCancel} className="btn btn-default">
              Cancel
            </button>
            <button
              onClick={this._onConfirm}
              className="btn btn-primary"
              disabled={countAssignedOutlets === 0}
            >
              Assign
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }

  _countAssignedOutlets = () => {
    let count = 0;
    this.props.outlets.forEach(o => {
      if (this._assigned(o.id)) {
        count++;
      }
    });
    return count;
  };

  _countShownOutlets = () => {
    let count = 0;
    this.props.outlets.forEach(o => {
      if (this._shown(o.id)) {
        count++;
      }
    });
    return count;
  };

  _countAssignedAndShown = () => {
    let count = 0;
    this.props.outlets.forEach(o => {
      if (this._assigned(o.id) && this._shown(o.id)) {
        count++;
      }
    });
    return count;
  };

  _onClickCheckAll = () => {
    const assignedOutletIds = { ...this.state.assignedOutletIds };
    this.props.outlets.forEach(o => {
      if (this._shown(o.id)) {
        assignedOutletIds[o.id] = true;
      }
    });
    this.setState({
      assignedOutletIds,
    });
  };

  _onClickUncheckAll = () => {
    const assignedOutletIds = { ...this.state.assignedOutletIds };
    this.props.outlets.forEach(o => {
      if (this._assignedAndShown(o.id)) {
        delete assignedOutletIds[o.id];
      }
    });
    this.setState({
      assignedOutletIds,
    });
  };

  _shown = outletId => {
    return this.state.searchedOutletIds.hasOwnProperty(outletId);
  };

  _assigned = outletId => {
    return this.state.assignedOutletIds.hasOwnProperty(outletId);
  };

  _assignedAndShown = outletId => {
    return this._shown(outletId) && this._assigned(outletId);
  };

  _onClickCheckbox = ({ id }) => {
    const { assignedOutletIds } = this.state;
    if (this.state.assignedOutletIds.hasOwnProperty(id)) {
      delete assignedOutletIds[id];
    } else {
      assignedOutletIds[id] = true;
    }
    this.setState({
      assignedOutletIds,
    });
  };

  _onChangeSearch = e => {
    const searchedOutletIds = {};
    const keyword = e.target.value;
    this.props.outlets.forEach(o => {
      if (keyword && keyword !== '') {
        if (o.name.search(new RegExp(keyword, 'i')) !== -1) {
          searchedOutletIds[o.id] = true;
        }
      } else {
        searchedOutletIds[o.id] = true;
      }
    });
    this.setState({
      search: keyword,
      searchedOutletIds,
    });
  };

  _onCancel = () => {
    this.props.onClickCancel();
  };

  _onConfirm = () => {
    const assignedOutletIds = Object.keys(this.state.assignedOutletIds);
    if (assignedOutletIds.length > 0) {
      this.props.onClickAssign({ assignedOutletIds });
    }
  };
}

AssignOutletModal.propTypes = {
  show: PropTypes.bool,
  outlets: PropTypes.array,
  assignedOutletIds: PropTypes.array,
  onClickCancel: PropTypes.func,
  onClickAssign: PropTypes.func,
};

AssignOutletModal.defaultProps = {
  show: false,
  outlets: [],
  assignedOutletIds: [],
};
export default AssignOutletModal;
